import { useState } from "react";
import { Calendar } from "@/components/ui/calendar";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";
import { CalendarIcon } from "lucide-react";
import { fmtDate } from "@/lib/date";

// value/onChange work with "yyyy-mm-dd" strings to match the backend
export function DatePicker({ label, value, onChange, testId }) {
  const [open, setOpen] = useState(false);
  const selected = value ? new Date(value + "T00:00:00") : undefined;

  const handle = (d) => {
    if (!d) return;
    const iso = `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}-${String(d.getDate()).padStart(2, "0")}`;
    onChange(iso);
    setOpen(false);
  };

  return (
    <label className="block">
      <span className="text-sm font-medium">{label}</span>
      <Popover open={open} onOpenChange={setOpen}>
        <PopoverTrigger asChild>
          <button
            type="button"
            data-testid={testId}
            className="mt-1 flex w-full items-center gap-2 rounded-lg border border-input bg-background px-3 py-2 text-left text-sm outline-none transition-colors hover:border-primary focus:ring-2 focus:ring-ring"
          >
            <CalendarIcon className="h-4 w-4 text-[hsl(var(--gold))]" />
            <span className={value ? "" : "text-muted-foreground"}>
              {value ? fmtDate(value) : "Pick a date"}
            </span>
          </button>
        </PopoverTrigger>
        <PopoverContent className="w-auto p-0" align="start">
          <Calendar
            mode="single"
            selected={selected}
            onSelect={handle}
            defaultMonth={selected}
            initialFocus
            captionLayout="dropdown-buttons"
            fromYear={2015}
            toYear={2030}
            classNames={{
              caption: "flex justify-center pt-1 relative items-center",
              caption_label: "hidden",
              caption_dropdowns: "flex gap-2",
              dropdown: "rounded-md border border-input bg-background px-2 py-1 text-sm outline-none focus:ring-2 focus:ring-ring",
              vhidden: "hidden",
            }}
          />
          {value && (
            <button
              type="button"
              onClick={() => { onChange(""); setOpen(false); }}
              className="w-full border-t border-border px-3 py-2 text-left text-xs text-muted-foreground hover:bg-secondary"
            >
              Clear date
            </button>
          )}
        </PopoverContent>
      </Popover>
    </label>
  );
}
